import React, {useState} from 'react';
import {IEvent, IPagedEventList} from "../../ModelContracts";
import useApi from "../../hooks/useApi/useApi";
import {useQuery} from "react-query";
import {Alert} from "../ui";
import EventCard from "../EventCard/EventCard";
import {Link} from "react-router-dom";

function RecentEvents() {
	const [events, setEvents] = useState<Array<IEvent>>([]);
	const [moreToLoad, setMoreToLoad] = useState<boolean>(false);
	const {getEvents} = useApi();
	useQuery<IPagedEventList>(
		['recent-events'],
		() => getEvents(),
		{
			onSuccess: (events: IPagedEventList) => {
				setEvents(events.items);
				setMoreToLoad(events.total > events.items.length);
			}
		}
	);

	return (
		<div>
			<h4 className="text-lg font-semibold mb-4">Recent Events</h4>
			{
				!events.length &&
				<Alert variant="secondary">No activity yet.</Alert>
			}
			<div className="flex flex-col gap-2">
				{
					events.map((event, i) => (
						<EventCard key={`event-${i}`} event={event} maxLength={42} />
					))
				}
			</div>
			{
				moreToLoad &&
				<Link to={`/channel`} className="btn btn-ghost btn-sm btn-block mt-4">
					<i className="bi bi-chevron-right"></i>
					View All
				</Link>
			}
		</div>
	);
}

export default RecentEvents;
